import React from "react";

// Badge discreto della piattaforma: non sostituisce mai il logo del club
export default function PoweredBy({ className = "", light = false, testid = "powered-by" }) {
  return (
    <a href="https://www.studionouvelle.it" target="_blank" rel="noreferrer" className={`inline-flex items-center gap-2 opacity-80 hover:opacity-100 transition-opacity ${className}`} data-testid={testid}>
      <img src="/icons/nouvelle-fidelity.png" alt="Nouvelle Fidelity" className="h-7 w-auto" draggable={false} />
      <span className={`text-[10px] leading-tight ${light ? "text-zinc-400" : "text-zinc-500"}`}>Piattaforma<br /><b className="font-semibold">Nouvelle Fidelity</b></span>
    </a>
  );
}
